import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseServiceService } from './base-service.service';
import { HttpHeaders } from '@angular/common/http';
import {envParams} from "../app/models/envParams-model";


@Injectable({
  providedIn: 'root'
})
export class ChatBotService extends BaseServiceService{


  public getChatLabels(language: string): Observable<any>{
    const url = '/bot-api/public/displayText?lang=' + language + '';
    return super.makeGetRequestBOt(url) as Observable<any>;
  }

  public sendChatEmail(body:object): Observable<any> {
    const url = '/bot-api/public/send/email';
    return super.makePostRequest(url, body) as Observable<any>;
  }

  public feedback(body:object): Observable<any> {
    const url = '/bot-api/public/feedback';
    return super.makePostRequest(url, body) as Observable<any>;
  }
  public logError(body:object): Observable<any> {
    const url = '/bot-api/public/log-error';
    return super.makePostRequest(url, body) as Observable<any>;
  }
  public getEnvironmentProperties(): Observable<envParams> {
    const url = '/bot-api/public/env-properties';
    const headers :HttpHeaders = new HttpHeaders().set('cache','true');
    return super.makeGetRequest(url,headers) as Observable<envParams>;
  }

  public downloadChat(body:object): Observable<any> {
    const url = '/bot-api/public/chat/download';
    const requestOptionsForBlob = { responseType: 'blob' as 'json' };
    return super.http().post(environment.hostUrl + url,body,  requestOptionsForBlob)
  }

  public checkAnyOnline(hostUrl: string): Observable<any> {
    const url = hostUrl + '/restapi/anyoneonline';
    return super.makeGetRequest(url) as Observable<any>;
  }


  public authenticateWithHeaders(hostUrl: string,  headers: HttpHeaders): Observable<any> {
    return super.makeLiveChatPostRequest(hostUrl,null,  headers) as Observable<any>;
  }
  public doLogout() : void {
    super.makeGetRequest('/hixmobile/AHCT/DisplayLogout.action')
      .pipe().subscribe();
      
  }

  public getUserDetails(tokenId: string,  userLoggedIn : string, authCookie: string): Observable<any> {

    let httpHeaders : HttpHeaders;
    if(tokenId !=""){
      httpHeaders = new HttpHeaders({
        'ClientSource': 'web', 'Access-Control-Allow-Origin': '*', [authCookie]:tokenId
      })
    }else {
      httpHeaders = new HttpHeaders({
        'ClientSource': 'web', 'Access-Control-Allow-Origin': '*'

      });
    }
    let url = '/hixmobile/public/consumerChatInitData';
    if (userLoggedIn ==='true') {
      url = '/hixmobile/consumerProtectedChatInitData'
    }
    return super.makeGetRequest(url,  httpHeaders) as Observable<any>;
  }
  public postUserDetails(  userLoggedIn : string, authCookie: string,body:any): Observable<any> {
    const httpHeaders: HttpHeaders = new HttpHeaders({
      'ClientSource': 'web', 'Access-Control-Allow-Origin': '*'
    });
    let url = '/hixmobile/public/consumerChatInitData';
    if ( userLoggedIn) {
      url = '/hixmobile/consumerProtectedChatInitData';
    }
    return super.makePostRequest(url, body,  httpHeaders) as Observable<any>;
  }
  public getChatInitSearchData(): Observable<any>{
    const url = '/hixmobile/public/consumerChatInitDataSearch';
    const httpHeaders: HttpHeaders = new HttpHeaders({
      'ClientSource': 'web', 'Access-Control-Allow-Origin': '*'
    });
    return super.makeGetRequestBOt(url, httpHeaders) as Observable<any>;
  }
  public postChatInitSearchData(body:any): Observable<any>{
    const url = '/hixmobile/public/consumerChatInitDataSearch';
    const httpHeaders: HttpHeaders = new HttpHeaders({
      'ClientSource': 'web', 'Access-Control-Allow-Origin': '*'
    });
    let finalBody = {"userSearchModel":body}
    return super.makePostRequest(url,finalBody, httpHeaders) as Observable<any>;
  }


  }
